import { whenBelow } from '../reveal.js';

const roundUpNumber = (num) => Math[(num % 20 === 1) ? 'floor' : 'ceil'](num / 20) * 20;

export default function (section) {
	const updateBackgroundSize = () => section.style.setProperty('--bg-size', `${roundUpNumber(section.getBoundingClientRect().height)}px`);

	new ResizeObserver(updateBackgroundSize).observe(section);

	const journey = section.querySelector('.journey');

	new IntersectionObserver(([entry]) => {
		if (entry.isIntersecting && !journey.classList.contains('in-view')) {
			journey.classList.add('in-view');
			// allSettled: switching to the mobile layout cancels the animations, which rejects finished.
			Promise.allSettled(journey.getAnimations({ subtree: true }).map((animation) => animation.finished)).then(() => journey.classList.add('drawn'));
		}
	}, { threshold: 0.5 }).observe(journey);

	// Without .drawn its animations are back, paused at the start; left halfway, they are rewound.
	whenBelow(journey, () => {
		journey.classList.remove('in-view', 'drawn');
		journey.getAnimations({ subtree: true }).forEach((animation) => {
			animation.currentTime = 0;
		});
	});
}
